import {
  Observable,
  BehaviorSubject,
  concat,
  of,
  debounceTime,
  distinctUntilChanged,
  tap,
  switchMap,
  catchError,
} from "rxjs";
import { Dialog, SharedModule, DataService } from "@bb-vendure/admin-ui/core";
import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
} from "@angular/core";
import { FetchSuppliersDocument } from "../../generated-graphql/graphql";

@Component({
  selector: "supplier-dialog",
  templateUrl: "./supplier-dialog.component.html",
  styleUrls: ["./supplier-dialog.component.scss"],
  standalone: true,
  imports: [SharedModule],
})
export default class SupplierDialogComponent implements Dialog, OnInit {
  constructor(protected dataService: DataService) {}

  resolveWith: (result?: any) => void;
  @Input() variantId: string;
  suppliers$: Observable<any>;
  isLoading = false;

  queryParams = new BehaviorSubject({
    pageIndex: 0,
    pageSize: 10,
    name: "",
  });
  sizeOptions = ["10", "20", "30", "40", "50"];

  ngOnInit(): void {
    this.suppliers$ = concat(
      of([]),
      this.queryParams.pipe(
        debounceTime(200),
        distinctUntilChanged(),
        tap(() => (this.isLoading = true)),
        switchMap((param) => {
          return this.dataService
            .query(FetchSuppliersDocument, {
              options: {
                pageIndex: param.pageIndex,
                pageSize: param.pageSize,
                name: param.name,
              },
            })
            .mapStream((suppilers) => {
              const res = suppilers.suppliers.result;
              console.log(res);
              return {
                data: res.data.vendInfo,
                info: {
                  ...res.pageInfo,
                },
              };
            })
            .pipe(
              catchError(() => of([])),
              tap(() => (this.isLoading = false))
            );
        })
      )
    );
  }
  onSizeSelect(size: string) {
    this.queryParams.next({
      ...this.queryParams.value,
      pageSize: Number(size),
    });
  }
  updateName(name: string) {
    this.isLoading = true;
    this.queryParams.next({ ...this.queryParams.value, name, pageIndex: 0 });
  }

  totalPageIndex(total:number) {
    return Math.ceil(total / this.queryParams.value.pageSize);
  }

  pageIndexButtons(total:number) {
    const pageIndex = this.queryParams.value.pageIndex;
    const totalPageIndex = this.totalPageIndex(total);
    let buttons:number[] = [];
  
    if (totalPageIndex <= 5) {
      for (let i = 0; i < totalPageIndex; i++) {
        buttons.push(i + 1);
      }
    } else {
      if (pageIndex < 3) {
        buttons = [1, 2, 3, 4];
      } else if (pageIndex > totalPageIndex - 2) {
        buttons = [totalPageIndex - 2, totalPageIndex - 1, totalPageIndex];
      } else {
        buttons = [pageIndex - 1, pageIndex, pageIndex + 1];
        if (pageIndex < totalPageIndex - 1) {
          buttons.push(pageIndex + 2);
        }
      }
      
      if (!buttons.includes(1)) {
        buttons.unshift(1);
      }
      if (!buttons.includes(totalPageIndex)) {
        buttons.push(totalPageIndex);
      }
    }
  
    return buttons;
  }

  onPageIndexSelect(index: any) {
    this.queryParams.next({
      ...this.queryParams.value,
      pageIndex: index,
    });
  }

  onSelect(supplier: any) {
    this.resolveWith(supplier);
  }
}
